import { gql } from '@apollo/client';

export type DashboardTask = {
  id: string;
  title?: string | null;
  description: string;
  localTaskId: string;
  statusName: string;
  statusId: string | null;
  priorityId: string | null;
  secretId: string | null;
  columnId: string | null;
  guestVisible: boolean | null;
  dueAt: string | null;
  createdAt: string;
  requester: { id: string; name: string | null; email: string | null } | null;
  url: string | null;
  site: string | null;
  kind: string;
  selectorInfo: Record<string, unknown> | string;
  browserInfo: Record<string, unknown> | string;
  data:
    | {
        coordinates?: Record<string, unknown>;
        userMetaData?: Record<string, unknown>;
      }
    | string
    | null;
  assignedUserIds: string[];
  tagIds: string[];
  tagNames: string[];
  watcherIds: string[];
  taskConnectionData: Record<string, unknown>[];
  fullstorySessionUrl: string | null;
  logrocketSessionUrl: string | null;
  sessionReplayAvailable: boolean;
  screenshotKey: string | null;
  screenshotUrl: string | null;
  screenshotErrors: { error: string; createdAt: string }[];
  retryScreenshotAt: string | null;
  attachments: {
    id: string;
    fileName: string;
    url: string;
    createdAt: string;
    sizeInKb: number;
  }[];
  referencedTasks: {
    id: string;
    localTaskId: string;
    display: string;
    priorityId: string | null;
  }[];
  column: {
    id: string;
    name: string | null;
    position: number | null;
    statusId: string | null;
    complete: boolean | null;
    projectId: string;
  } | null;
  project: {
    id: string;
    name: string;
    apiKey: string;
    organizationId: string;
  };
};

export type DashboardTaskData = {
  currentUser: { id: string; task: DashboardTask | null };
};

export type DashboardTaskVars = { id: string };

export const GET_DASHBOARD_TASK = gql`
  query getDashboardTask($id: ID!) {
    currentUser {
      id
      task(id: $id) {
        id
        title
        description
        localTaskId
        statusName
        statusId
        priorityId
        secretId
        columnId
        guestVisible
        dueAt
        createdAt
        requester {
          id
          name
          email
        }
        url
        site
        kind
        selectorInfo
        browserInfo
        data
        assignedUserIds
        tagIds
        tagNames
        watcherIds
        taskConnectionData
        fullstorySessionUrl
        logrocketSessionUrl
        sessionReplayAvailable
        screenshotKey
        screenshotUrl
        retryScreenshotAt
        screenshotErrors {
          error
          createdAt
        }
        attachments {
          id
          fileName
          url
          createdAt
          sizeInKb
        }
        referencedTasks {
          id
          localTaskId
          display
          priorityId
        }
        column {
          id
          name
          position
          statusId
          complete
          projectId
        }
        project {
          id
          name
          apiKey
          organizationId
        }
      }
    }
  }
`;
